import axios from '../plugins/axios'

export default {
  create(params){
    return axios.post('/api/v1/scenario_popups/create', params)
  },
  copy(params){
    return axios.post('/api/v1/scenario_popups/copy', params)
  }
}
